import { uid } from 'radash';

import { diagram } from '@diagram/state/diagram';

import { DiagramCommunication, DiagramCommunicationSchema } from 'models';
import { SyncEngineHelpers } from 'helpers/SyncEngineHelpers';

const CommunicationService = {
    get: (id: string) => {
        return diagram.communications[id];
    },

    getForComponentInstance: (componentInstanceId: string) => {
        return Object.values(diagram.communications).filter(
            (communication) => communication.from === componentInstanceId || communication.to === componentInstanceId,
        );
    },

    generatePrettyId: (communication: DiagramCommunication) => {
        let hash = 216613626139583;

        for (let i = 0; i < communication.id.length; i++) {
            hash ^= communication.id.charCodeAt(i);
            hash += (hash << 1) + (hash << 4) + (hash << 7) + (hash << 8) + (hash << 24);
        }

        return (Math.abs(hash) % 100_000).toString();
    },

    add: (data: Partial<DiagramCommunication>) => {
        const communication = DiagramCommunicationSchema.parse({
            id: `communication-${uid(6)}`,
            ...data,
        });

        diagram.communications[communication.id] = communication;
    },

    update: (id: string, data: Partial<DiagramCommunication>) => {
        Object.entries(data).map(([key, value]) => {
            SyncEngineHelpers.set(diagram.communications[id], key, value);
        });
    },

    delete: (id: string) => {
        delete diagram.communications[id];
    },
};

export { CommunicationService };
